import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/ad.png'


const _withScopeId = n => (_pushScopeId("data-v-190cd770"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = {
  key: 0,
  class: "content"
}
const _hoisted_3 = { class: "courierNumber" }
const _hoisted_4 = { class: "company" }
const _hoisted_5 = { class: "number" }
const _hoisted_6 = { class: "statusOrTime" }
const _hoisted_7 = { class: "status" }
const _hoisted_8 = { class: "time" }
const _hoisted_9 = { class: "context" }
const _hoisted_10 = { class: "info" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_12 = { class: "info-content" }
const _hoisted_13 = { class: "address" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-right":"10px"} }, "送至", -1))
const _hoisted_15 = { class: "userInfo" }

import { ref, reactive, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import {
  Button,
  Field,
  CellGroup,
  Toast,
  NavBar,
  Icon,
  CountDown,
  Divider,
  GridItem,
  Steps,
  Step,
  Empty,
} from "vant";
import router from "@/router";
import { request } from "@/provide/fetch";

export default /*#__PURE__*/_defineComponent({
  name: 'logistics',
  setup(__props) {

const route = useRoute();
// import { logisticsdetail } from "@/api/shop";
//101 揽件102 在途中103 派送中104 已签收 (完结状态)105 用户拒签
// 106 疑难件107 无效单 (完结状态) 108 超时单
// 109 签收失败110 退回111 转投112 待签113 邮件回收'
const logisticsStatus = [
  {
    name: "揽件",
    value: "101",
  },
  {
    name: "在途中",
    value: "102",
  },
  {
    name: "派送中",
    value: "103",
  },
  {
    name: "已签收",
    value: "104",
  },
  {
    name: "用户拒签",
    value: "105",
  },
  {
    name: "疑难件",
    value: "106",
  },
  {
    name: "无效单",
    value: "107",
  },
  {
    name: "超时单",
    value: "108",
  },
  {
    name: "签收失败",
    value: "109",
  },
  {
    name: "退回",
    value: "110",
  },
  {
    name: "转投",
    value: "111",
  },
  {
    name: "待签",
    value: "112",
  },
  {
    name: "邮件回收",
    value: "113",
  },
];
const filterLogisticsStatus = (value: any) => {
  return (
    logisticsStatus.filter((item) => item.value == value)[0]?.name || "未知"
  );
};
const state = ref<any>({});
const logisticsVisible = ref(true);
request({
  url: `/order/find-logistic-detail`,
  method: "POST",
  data: {
    orderNo: route.params.id,
    logisticsNo: route.params.logisticsNo,
  },
}).then((res) => {
  if (res.code == 200) {
    logisticsVisible.value = false;
    state.value = res.data;
  } else {
    Toast(res.message)
  }
});
// 复制状态
const copied = ref(false);

// 复制文本的函数
const copyText = async () => {
  try {
    // 使用 Clipboard API 将文本复制到剪贴板
    await navigator.clipboard.writeText(state.value.logisticsNo);
    console.log("showSuccessToast 类型:", typeof showSuccessToast);
    copied.value = true;
    // // 可以设置一个定时器来隐藏提示信息
    setTimeout(() => {
      copied.value = false;
      Toast.success("复制成功");
    }, 0);
  } catch (error) {
    console.error("复制失败:", error);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(NavBar), {
      title: "查看物流",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).go(-1)))
    }, {
      left: _withCtx(() => [
        _createVNode(_unref(Icon), {
          color: "rgba(0,0,0,0.9)",
          name: "arrow-left",
          size: "20"
        })
      ]),
      _: 1
    }),
    (!logisticsVisible.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(state.value.logisticsCompany) + "：", 1),
            _createElementVNode("span", _hoisted_5, _toDisplayString(state.value.logisticsNo), 1),
            _createElementVNode("span", {
              class: "action",
              onClick: copyText
            }, "复制")
          ]),
          _createVNode(_unref(Steps), {
            class: "content-Steps",
            direction: "vertical",
            active: 0
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.value.logisticsDetail, (step, index) => {
                return (_openBlock(), _createBlock(_unref(Step), {
                  class: "content-Steps-item",
                  key: index
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, _toDisplayString(filterLogisticsStatus(step.status)), 1),
                      _createElementVNode("div", _hoisted_8, _toDisplayString(step.time), 1)
                    ]),
                    _createElementVNode("div", _hoisted_9, _toDisplayString(step.context), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("span", null, _toDisplayString(state.value.receiverProvince) + _toDisplayString(state.value.receiverCity) + _toDisplayString(state.value.receiverDistrict) + _toDisplayString(state.value.receiverAddress), 1)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("span", null, _toDisplayString(state.value.receiverName), 1),
                _createElementVNode("span", null, _toDisplayString(state.value.receiverMobile), 1)
              ])
            ])
          ])
        ]))
      : (_openBlock(), _createBlock(_unref(Empty), {
          key: 1,
          image: "network",
          description: "暂无物流信息"
        }))
  ]))
}
}

})